import { Col } from 'reactstrap';
import { Featured, HighestPrices, LowestPrices, ShowingProducts } from '../../../../../../Utils/Constants';

export default function Sorting() {
    return (
        <Col md={6} className="text-sm-end">
            <span className="f-w-600 m-r-5"> {ShowingProducts}</span>
            <div className="select2-drpdwn-product select-options d-inline-block">
                <select  className="form-control btn-square" name="select">
                    <option value="opt1">{Featured}</option>
                    <option value="opt2">{LowestPrices}</option>
                    <option value="opt3">{HighestPrices}</option>
                </select>
            </div>
        </Col>
    )
}
